import { CommonUtilities } from 'commonUtils';
import React, { useEffect, useState } from 'react';
import Drawer from 'react-modern-drawer';

export default function ProjectStatusUpsert(param: any) {
    console.log(param)

    let [projectStatus, setProjectStatus] = useState<any>(param?.editDataDawer ?? []);

    const closeDrawer = () => { param.closeDrawer() }

    const onReset = () => {
        console.log(param?.editDataDawer)
        if (param?.editDataDawer) {
            projectStatus = param?.editDataDawer
            setProjectStatus(projectStatus)
        }
    }

    const onSave = () => {
        systemFormatsList.saveProjectStatus(projectStatus).then((respond: any) => {
            CommonUtilities.showToastDawer('Contract Status Saved', 'Success')
        })
    }

    return (<>
        <Drawer open={param?.openUpsertUX} direction='right' className='react-drawer allowHscroll' size={800}>

            <div className="pull-right ws-5 box full-height-vh">

                <div className="ws-12 bg-blue ">
                    <h1 className="pull-left text-center mt mll">Add Project Status</h1>
                    <i className="icon-close pull-right pLarge" onClick={closeDrawer}></i>
                </div>

                <div className="box-content">

                    <div className="ws-12">
                        <div className="ws-12 pbl">
                            <label className="ws-12 text-bold pb">Project Status</label>
                            <div className="label-entries">
                                <input type="number" className="ws-12" placeholder="Project Status" value={projectStatus?.projectStatus ?? ""} onChange={(e: any) => setProjectStatus({ ...projectStatus, projectStatus: e.target.value })} name="projectStatus" />
                            </div>
                        </div>

                        <div className="ws-12 pbl">

                            <label className="ws-12 text-bold pb" >Project Status Name</label>
                            <div className="label-entries">
                                <input type="text" className="ws-12" placeholder="Project Status Name" value={projectStatus?.statusDescription ?? ""} onChange={(e: any) => setProjectStatus({ ...projectStatus, statusDescription: e.target.value })} name="statusDescription" />
                            </div>
                        </div>
                    </div>
                </div>

                {/* Footer */}
                <div className="box-footer ws-12 pull-right">
                    <button type="button" className="icon-btn delete pull-right" onClick={closeDrawer}>x Close</button>
                    <button type="button" className="icon-btn delete pull-right" onClick={onReset}>↻ Reset</button>
                    <button type="button" className="icon-btn edit pull-right" onClick={onSave}>✔ Save </button>
                </div>

            </div>

        </Drawer>
    </>)
}